/**
 * Översätter Supabase auth-felmeddelanden till svenska.
 * Användning: setErr(translateAuthError(error.message));
 */
export function translateAuthError(message?: string | null): string {
  if (!message) return "Något gick fel. Försök igen.";
  const m = message.toLowerCase();

  if (m.includes("invalid login credentials") || m.includes("invalid_credentials"))
    return "Fel e-post eller lösenord.";
  if (m.includes("email not confirmed") || m.includes("email_not_confirmed"))
    return "Du måste bekräfta din e-post innan du kan logga in. Kolla din inkorg.";
  if (m.includes("user already registered") || m.includes("already registered") || m.includes("user_already_exists"))
    return "Den här e-posten har redan ett konto. Logga in i stället.";
  if (m.includes("password should be at least") || m.includes("weak_password"))
    return "Lösenordet är för svagt. Använd minst 8 tecken med blandade tecken.";
  if (m.includes("invalid email") || m.includes("email_address_invalid"))
    return "Ogiltig e-postadress.";
  if (m.includes("rate limit") || m.includes("too many requests") || m.includes("over_email_send_rate_limit"))
    return "För många försök. Vänta en stund och försök igen.";
  if (m.includes("token has expired") || m.includes("otp_expired") || m.includes("expired"))
    return "Länken har gått ut. Begär en ny.";
  if (m.includes("network") || m.includes("fetch"))
    return "Anslutningsproblem. Kontrollera din internetuppkoppling.";
  if (m.includes("user not found"))
    return "Vi hittade inget konto med den e-posten.";
  if (m.includes("same password"))
    return "Det nya lösenordet får inte vara samma som det gamla.";
  if (m.includes("signup is disabled") || m.includes("signup_disabled"))
    return "Registrering är tillfälligt avstängd.";
  if (m.includes("unauthorized") || m.includes("not authorized"))
    return "Du har inte behörighet att utföra den här åtgärden.";

  // Fallback: visa originalet om det är kort, annars generisk text
  if (message.length < 80) return message;
  return "Något gick fel. Försök igen.";
}

export function isRepeatedSignupResponse(data: {
  user?: { identities?: unknown[] | null } | null;
  session?: unknown | null;
} | null | undefined) {
  return Boolean(
    data?.user &&
    !data.session &&
    Array.isArray(data.user.identities) &&
    data.user.identities.length === 0,
  );
}
